module.exports = __webpack_public_path__ + "media/images/steps/step_16-b4cca764d4c1946746a1b9c532c2e058.svg";